export default {
    firstName: {
        required: true,
        maxlength: 30
    },
    lastName: {
        required: true,
        maxlength: 30
    },
    street: {
        required: true
    },
    postalCode: {
        required: true,
        postal_code: true
    },
    city: {
        required: true
    },
    email: {
        required: true,
        email: true
    },
    phone: {
        required: false,
        optional_phone: true 
    },
}